(function () {
  const nav = document.querySelector('[data-pdp-sticky-nav]');
  if (!nav) return;

  const items = Array.from(nav.querySelectorAll('.pdp-sticky-nav-item'));
  if (!items.length) return;

  const isMobile = window.innerWidth < 750;
  const currentEl = nav.querySelector('[data-nav-current]');

  // Build targets — hide pills whose section is absent or not visible on this page
  const rawTargets = items.map(item => {
    const el = document.querySelector(item.dataset.target);
    const present = el !== null && getComputedStyle(el).display !== 'none';
    if (!present) item.style.display = 'none';
    return { item, el, present };
  }).filter(({ present }) => present);

  const targets = rawTargets.map(({ item, el }, i) => ({ item, el, index: i + 1 }));

  if (!targets.length) return;

  // Update counter total to match only present pills
  const counterTotal = nav.querySelector('.pdp-sticky-nav-counter > span:last-child');
  if (counterTotal) counterTotal.textContent = targets.length;

  let activeItem = null;

  function activate(item, index) {
    if (item === activeItem) return;
    activeItem = item;
    items.forEach((i) => i.classList.remove('is-active'));
    item.classList.add('is-active');
    if (currentEl) currentEl.textContent = index;
    if (isMobile) {
      item.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  }

  activate(targets[0].item, targets[0].index);

  if (isMobile) {
    const headerEl =
      document.querySelector('header.header') ||
      document.querySelector('.header--mobile-center') ||
      document.querySelector('sticky-header') ||
      document.querySelector('.shopify-section-group-header-group') ||
      document.querySelector('.header-wrapper');

    function getHeaderBottom() {
      return headerEl ? Math.max(0, headerEl.getBoundingClientRect().bottom) : 0;
    }

    function updateTop() {
      nav.style.top = getHeaderBottom() + 'px';
    }

    updateTop();
    window.addEventListener('scroll', updateTop, { passive: true });
    window.addEventListener('resize', updateTop);

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', updateTop, { passive: true });
    }

    const sectionHeader = document.querySelector('.section-header');
    if (sectionHeader) {
      new MutationObserver(updateTop).observe(sectionHeader, { attributes: true, attributeFilter: ['class'] });
      sectionHeader.addEventListener('transitionend', (e) => {
        if (e.target === sectionHeader) updateTop();
      }, { passive: true });
    }

    nav.style.opacity = '0';
    nav.style.pointerEvents = 'none';

    function updateVisibility() {
      const scrollable = document.documentElement.scrollHeight - window.innerHeight;
      const show = scrollable > 0 && (window.scrollY / scrollable) >= 0.02;
      nav.style.opacity = show ? '1' : '0';
      nav.style.pointerEvents = show ? '' : 'none';
    }

    updateVisibility();
    window.addEventListener('scroll', updateVisibility, { passive: true });
  }

  function onIntersection(entries) {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const found = targets.find(({ el }) => el === entry.target);
      if (found) activate(found.item, found.index);
    });
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '-50% 0px -50% 0px',
    threshold: 0
  });

  targets.forEach(({ el }) => observer.observe(el));

  targets.forEach(({ item, el }) => {
    item.addEventListener('click', () => {
      const offset = isMobile
        ? (parseInt(nav.style.top) || 0) + nav.offsetHeight
        : 80;
      const top = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  });
})();
